export default __webpack_public_path__ + "static/media/teamwork.bc82a17e.svg";